
















import { Vue, Component } from 'vue-property-decorator';
import { AccessControlConfigInterface } from '@core/interfaces/access-control-config-interface';
import SubscriptionTable from '@subscriptions/components/tables/subscription-table/subscription-table.vue';

@Component({
  name: 'bc-subscription-payment-follow-up',
  components: {
    'bpc-subscription-table': SubscriptionTable,
  },
})
export default class SubscriptionPaymentFollowUp extends Vue {
  get accessControlConfig(): AccessControlConfigInterface {
    return this.$store.getters['centerSettings/accessControlConfig'];
  }

  get extendedFilterConfigName() {
    return this.accessControlConfig?.access_control_service === 'finddoc'
      ? 'extended-with-finddoc-sync'
      : 'extended';
  }

  get fetchPath() {
    const url = this.$bpcApiRouteHelper.getEntityPath('subscription');
    return `${url}/payments-follow-up`;
  }
}
